/*
 * Product page accordions (hero Key Benefits / Ingredients / How To Use, and
 * the FAQ), animated the way GemPages' were.
 *
 *   <div data-qp-acc-group>                 one open at a time inside a group
 *     <details data-qp-acc>
 *       <summary>...</summary>
 *       <div data-qp-acc-panel>...</div>     the part that grows and shrinks
 *     </details>
 *   </div>
 *
 * A click toggles .is-open on the <details> straight away (the icon and title
 * colour key off it), then the panel's height eases open or shut over 450ms,
 * which is how long GemPages' took when timed frame by frame (its CSS said
 * 500ms, but it settles sooner). The <details> stays open
 * until a closing panel reaches zero, so the content is still there to watch
 * it shut. Without this script the <details> still open and close natively.
 *
 * Included by more than one section, so it guards against running twice and
 * listens on the document rather than on each accordion.
 */
(function () {
  if (window.qpAccordion) return;
  window.qpAccordion = true;

  var DURATION = 450;
  var EASING = 'ease';
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function panelOf(details) {
    for (var i = 0; i < details.children.length; i++) {
      if (details.children[i].hasAttribute('data-qp-acc-panel')) return details.children[i];
    }
    return null;
  }

  function setOpen(details, open) {
    var panel = panelOf(details);
    // Where the panel is right now, even halfway through an earlier animation.
    var from = details.open && panel ? panel.getBoundingClientRect().height : 0;

    if (details.qpAnimation) {
      details.qpAnimation.cancel();
      details.qpAnimation = null;
    }

    details.classList.toggle('is-open', open);
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) details.open = true;

    if (!panel || !panel.animate || (reduceMotion && reduceMotion.matches)) {
      details.open = open;
      return;
    }

    var to = open ? panel.scrollHeight : 0;
    if (Math.abs(to - from) < 1) {
      details.open = open;
      return;
    }

    var animation = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: DURATION,
      easing: EASING,
      fill: 'forwards'
    });
    details.qpAnimation = animation;
    animation.onfinish = function () {
      if (details.qpAnimation !== animation) return;
      details.qpAnimation = null;
      if (!open) details.open = false;
      animation.cancel();
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('details[data-qp-acc] > summary');
    if (!summary) return;
    event.preventDefault();

    var details = summary.parentElement;
    var opening = !details.classList.contains('is-open');

    if (opening) {
      var group = details.closest('[data-qp-acc-group]');
      if (group) {
        group.querySelectorAll('details[data-qp-acc].is-open').forEach(function (other) {
          if (other !== details) setOpen(other, false);
        });
      }
    }
    setOpen(details, opening);
  });

  // Mark accordions as script-driven, and carry over any that start open.
  function prepare(scope) {
    scope.querySelectorAll('details[data-qp-acc]').forEach(function (details) {
      details.classList.add('is-ready');
      details.classList.toggle('is-open', details.open);
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prepare(document); });
  } else {
    prepare(document);
  }
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target); });
})();
